import { httpService } from '@/services/HttpService';
import { CreditCardData } from '@/interfaces/CreditCardData';

class CreditCardService {
  getToken(cardData: CreditCardData, successCallback: any, errorCallback: any) {
    const options = {
      url: 'https://direct.paylane.com/rest.js/cards/generateToken',
      data: JSON.stringify(cardData),
      type: 'POST',
    };
    const request = new XMLHttpRequest();

    request.open(options.type.toUpperCase(), options.url);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    request.onreadystatechange = function() {
      if (request.DONE === request.readyState) {
        if (request.status === 200) {
          const data = JSON.parse(request.responseText);
          successCallback(data);
        } else {
          errorCallback(request.readyState);
        }
      }
    };

    request.send(options.data);
  }
  sendCreditCardToken(workspaceId: number, data: any): Promise<any> {
    return httpService.post(`workspaces/${workspaceId}/credit_card`, data);
  }
  getCreditCardData(workspaceId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/credit_card`, {}, { isErrorSuppressed: true });
  }
}

export const creditCardService = new CreditCardService();
